import { Card, CardContent, Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { IContactGroupAddress } from 'contacts/types';
import { LabeledValue } from 'core/elements';
import { Direction, Variant } from 'theme/enums';

interface IProps {
  address: IContactGroupAddress;
}

export const AddressDetails = ({ address }: IProps) => {
  const { t } = useTranslation();

  const addressLine = [address.line1, address.line2].filter(Boolean).join(' ');

  return (
    <Card variant={Variant.PLAIN}>
      <CardContent>
        <Stack direction={Direction.COLUMN} spacing={1}>
          {address.accountsReceivableId && (
            <LabeledValue label={t('labelAccountNumber')} value={address.accountsReceivableId} />
          )}
          {address.externalCustomerNumber && (
            <LabeledValue label={t('labelCustomerNumber')} value={address.externalCustomerNumber} />
          )}
          <LabeledValue label={t('labelLocationName')} value={address.name} />
          <LabeledValue label={t('labelStreetAddress')} value={addressLine} />
          <LabeledValue label={t('labelCity')} value={address.city} />
          <LabeledValue label={t('labelState')} value={address.state} />
          <LabeledValue label={t('labelPostalCode')} value={address.zip} />
          <LabeledValue label={t('labelCountry')} value={address.country} />
        </Stack>
      </CardContent>
    </Card>
  );
};
